(function () {
  // Console logs: run window.__STOCK_BADGE_DEBUG__ = true to enable
  window.__STOCK_BADGE_VERSION = "v3-ajax+preorder-note";
  function log(){try{ if(window.__STOCK_BADGE_DEBUG__) console.debug.apply(console, arguments);}catch(e){}}
  function onReady(fn){ if(document.readyState!=='loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  var LOW_STOCK_THRESHOLD = 5;
  var PREORDER_WORDS = ['pre order','pre-order','preorder'];
  var PREORDER_NOTE = ''; // <- your outside note text

  var PRICE_SELECTORS = [
    '.product-price__current-price',
    '.product-price__cost',
    '.product-price__content',
    '.product-price',
    '.product__price .money',
    '.product__price [data-money]',
    '[data-product-price] .money',
    '[data-product-price]',
    '.product__price',
    '.product-price__current',
    '.price__current',
    '.price .money',
    '.price'
  ];

  function getSectionRoot(){
    var form = document.querySelector('form[action^="/cart/add"]');
    return (form && form.closest('[id^="shopify-section"]')) || document;
  }
  function getProductForm(root){ return root.querySelector('form[action^="/cart/add"]'); }

  function tryReadProductJsonFromDom(){
    var el = document.getElementById('ProductJson')
      || document.querySelector('[id^="ProductJson-"]')
      || document.querySelector('script[type="application/json"][data-product-json]')
      || document.querySelector('[data-product-json]');
    if (!el) return null;
    try { return JSON.parse(el.textContent || el.innerHTML || el.dataset.product); }
    catch(e){ return null; }
  }

  function handleFromUrl(){
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  async function fetchProductJson(){
    var handle = handleFromUrl();
    if (!handle) return null;
    try {
      var res = await fetch('/products/' + handle + '.js');
      if (!res.ok) return null;
      return await res.json();
    } catch (e) { return null; }
  }

  async function getProductData(){
    return tryReadProductJsonFromDom() || (await fetchProductJson());
  }

  function getCurrentVariant(root, product){
    if (!product || !product.variants) return null;
    var form = getProductForm(root);
    var idInput = form && (form.querySelector('input[name="id"]') || form.querySelector('select[name="id"]'));
    var vid = idInput ? parseInt(idInput.value, 10) : null;
    if (vid){
      var v = product.variants.find(function(x){ return x.id === vid; });
      if (v) return v;
    }
    return product.variants[0] || null;
  }

  function isPreorderByStoq(root){
    var atc = root.querySelector('button[name="add"], button[type="submit"], [data-add-to-cart], [data-product-atc]');
    var atcText = atc ? (atc.textContent||'').trim().toLowerCase() : '';
    for (var i=0;i<PREORDER_WORDS.length;i++){
      if (atcText.indexOf(PREORDER_WORDS[i]) !== -1) return true;
    }
    if (root.querySelector('[data-stoq-preorder], .stoq-preorder, [id*="stoq"], [class*="stoq"]')) return true;
    if (window.STOCK_Badge_Force_Preorder === true) return true;
    return false;
  }

  function findPriceAnchor(root){
    for (var i=0;i<PRICE_SELECTORS.length;i++){
      var el = root.querySelector(PRICE_SELECTORS[i]);
      if (el) { return el; }
    }
    return null;
  }

  function ensureBadgeSibling(anchor){
    var parent = anchor.parentNode || anchor;
    // reuse existing sibling badge
    var kids = Array.prototype.slice.call(parent.childNodes||[]);
    for (var i=0;i<kids.length;i++){
      var n = kids[i];
      if (n.nodeType===1 && n.hasAttribute && n.hasAttribute('data-stock-badge')) return n;
    }
    var badge = document.createElement('span');
    badge.setAttribute('data-stock-badge','');
    badge.className = 'price-badge price-badge--in';
    if (anchor.nextSibling) parent.insertBefore(badge, anchor.nextSibling);
    else parent.appendChild(badge);
    if (parent.classList) parent.classList.add('price-and-stock--inline');
    return badge;
  }

  // NEW: helper to ensure/remove the outside preorder note
  function setPreorderNote(badge, noteText){
    var parent = badge.parentNode;
    if (!parent) return;
    // remove existing note (if any)
    var existing = parent.querySelector('.price-preorder-note');
    if (existing) existing.remove();
    if (!noteText) return; // nothing to add
    var note = document.createElement('span');
    note.className = 'price-preorder-note';
    note.textContent = noteText;
    parent.insertBefore(note, badge.nextSibling);
  }

  function classify(root, variant){
    // Pre-order first (Stoq UI OR native)
    if (isPreorderByStoq(root) || (!variant.available && variant.inventory_policy === 'continue')) {
      return { text:'Pre Order: Arriving mid November', cls:'preorder', note: PREORDER_NOTE };
    }
    var qty = (typeof variant.inventory_quantity === 'number') ? variant.inventory_quantity : null;
    if (variant.available){
      if (qty !== null && LOW_STOCK_THRESHOLD > 0 && qty <= LOW_STOCK_THRESHOLD) {
        return { text:'Low stock', cls:'low', note: null };
      }
      return { text:'In Stock: Delivered in 2-4 Days', cls:'in', note: null };
    }
    return { text:'Sold Out', cls:'out', note: null };
  }

  async function render(root){
    var product = await getProductData();
    if (!product){ log('[badge] no product data'); return {ok:false, reason:'no-product'}; }
    var variant = getCurrentVariant(root, product);
    if (!variant){ log('[badge] no variant'); return {ok:false, reason:'no-variant'}; }
    var anchor = findPriceAnchor(root);
    if (!anchor){ log('[badge] no anchor'); return {ok:false, reason:'no-anchor'}; }

    var badge = ensureBadgeSibling(anchor);
    var state = classify(root, variant);
    badge.textContent = state.text;
    badge.className = 'price-badge price-badge--' + state.cls;

    // NEW: add/remove preorder note
    setPreorderNote(badge, state.note);

    log('[badge] rendered:', state);
    return {ok:true, state, anchor, badge};
  }

  function renderFromVariant(root, variant){
    var anchor = findPriceAnchor(root); if (!anchor) return;
    var badge = ensureBadgeSibling(anchor);
    var s = classify(root, variant);
    badge.textContent = s.text;
    badge.className = 'price-badge price-badge--' + s.cls;
    setPreorderNote(badge, s.note); // NEW
  }

  function wire(root){
    // initial (async) render
    render(root);

    document.addEventListener('variant:change', function(e){
      if (e.detail && e.detail.variant){ renderFromVariant(root, e.detail.variant); }
    });
    document.addEventListener('variant:changed', function(e){
      if (e.detail && e.detail.variant){ renderFromVariant(root, e.detail.variant); }
    });

    var form = getProductForm(root);
    if (form){
      form.addEventListener('change', function(){
        // on form change we re-run full render (handles id change + DOM swaps)
        render(root);
      }, {passive:true});
    }

    var mo = new MutationObserver(function(){ render(root); });
    mo.observe(root, { childList:true, subtree:true });
  }

  // Diagnostics API (kept)
  window.__stockBadgeDiag = {
    version: function(){ return window.__STOCK_BADGE_VERSION || 'unknown'; },
    scan: async function(){
      var root = getSectionRoot();
      var form = getProductForm(root);
      var domJson = tryReadProductJsonFromDom();
      var ajaxJson = domJson ? true : !!(await fetchProductJson());
      var anchor = findPriceAnchor(root);
      var atc = root.querySelector('button[name="add"], button[type="submit"], [data-add-to-cart], [data-product-atc]');
      var atcText = atc ? (atc.textContent||'').trim() : '';
      return {
        version: window.__STOCK_BADGE_VERSION,
        rootFound: !!root, formFound: !!form,
        domProductJsonFound: !!domJson, ajaxProductJsonReachable: ajaxJson,
        anchorFound: !!anchor, atcText: atcText
      };
    },
    render: function(){ var root = getSectionRoot(); return render(root); },
    forcePreorder: function(on){ window.STOCK_Badge_Force_Preorder = !!on; var root = getSectionRoot(); return render(root); }
  };

  onReady(function(){
    var root = getSectionRoot();
    if (!root) return;
    wire(root);
  });
})();
